import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  LoginGuard,
  AdminProfileGuard,
  SocioProfileGuard
} from 'app/guards/guards.index';


@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    LoginGuard,
    AdminProfileGuard,
    SocioProfileGuard
  ],
  declarations: []
})
export class GuardsModule { }



// WEBPACK FOOTER //
// ./src/app/guards/guards.module.ts